import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {WeaLocaleProvider, WeaNewScroll, WeaInputLocale} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const getCurrentLabel = WeaInputLocale.getCurrentLabel;
const getMultiStrFromBase64 = WeaInputLocale.getMultiStrFromBase64;
// import E9FreqUseMenuSetting from './E9FreqUseMenuSetting';
import E9FreqUseMenuSetting from './E9FreqUseMenuSettingNew';

@inject('portalThemeStore')
@observer
class E9FreqUseMenuContent extends React.Component {
    constructor(props) {
        super(props);
        this.getFreqUseMenu = this.getFreqUseMenu.bind(this);
        this.onFreqUseMenuClick = this.onFreqUseMenuClick.bind(this);
    }

    render() {
        const {portalThemeStore} = this.props;
        const {freqUseMenu=[], account} = portalThemeStore;
        const _freqUseMenu = toJS(freqUseMenu);
        const _account = toJS(account);

        return (
            <div className="e9header-freq-use-menu-content">
                <div style={{padding: '5px 0'}}>
                    <WeaNewScroll height="100%">
                        <div className="e9header-freq-use-menu-items">
                            {
                                _freqUseMenu.map((item, index) => {
                                    const {infoid:id, menunamemultlang: name} = item;

                                    return (
                                        <div key={index}
                                             data-id={id}
                                             className="e9header-freq-use-menu-item"
                                             title={getCurrentLabel(getMultiStrFromBase64(name))}
                                             onClick={() => this.onFreqUseMenuClick(item)}
                                        >
                                            {getCurrentLabel(getMultiStrFromBase64(name))}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </WeaNewScroll>
                </div>
                <div className="e9header-freq-use-menu-setting" title={getLabel(19653, '设置')} onClick={() => this.props.onVisibleChange(false)}>
                    <E9FreqUseMenuSetting account={_account} callback={this.getFreqUseMenu}>
                        <i className="wevicon-freq-use-menu-setting"/>
                        <span style={{marginLeft: '5px'}}>{getLabel(19653, '设置')}</span>
                    </E9FreqUseMenuSetting>
                </div>
            </div>
        );
    }

    getFreqUseMenu() {
        const {portalThemeStore} = this.props;
        portalThemeStore.getFreqUseMenu();
    }

    onFreqUseMenuClick(item) {
        let obj = {...item};
        for(let k in item){
            if (item.hasOwnProperty(k)) {
                if (k == 'menulink'){
                    obj.url = item[k];
                }else if (k == 'linktype') {
                    if (item[k] == '0') {
                        obj.target = 'mainFrame';
                    } else {
                        obj.target = '_blank';
                    }
                }
            }
        }
        this.props.onVisibleChange(false);
        const {portalThemeStore} = this.props;
        portalThemeStore.onLoadMain(obj);
    }
}

export default E9FreqUseMenuContent;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9FreqUseMenuContent.js